import { MenuAction } from '@shared/interfaces/header/menu-action';
import { CircleStop, PlusSquare, Sigma, Trash } from 'lucide-angular';

export const meteringPointSourceMenuAction: MenuAction[] = [
  {
    id: 'addMeter',
    title: 'meteringpoint.source.addmeter.title',
    icon: PlusSquare,
  },
  {
    id: 'addCalculation',
    title: 'meteringpoint.source.addcalculation.title',
    icon: Sigma,
  },
  {
    id: 'addControlMeter',
    title: 'meteringpoint.source.addcontrolmeter.title',
    icon: PlusSquare,
  },
  {
    id: 'stopControlMeter',
    title: 'meteringpoint.source.stopcontrolmeter.title',
    icon: CircleStop,
    iconColor: 'text-red-500',
    breaker: true,
  },
  {
    id: 'remove',
    title: 'meteringpoint.source.remove.title',
    icon: Trash,
    iconColor: 'text-red-500',
  },
];
